import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export const ZDeviceType = z.object({
  asset_type_id: z.string(),
  asset_type_name: z.string(),
  category_type_id: z.string(),
  category_type_name: z.string(),
  isCustomDevice: z.boolean(),
  isDeviceModelApplicable: z.boolean()
})

export const ZDeviceTypeData = z.array(ZDeviceType)

export const ZDeviceTypeApiResponse = z.object({
  http_status: z.any(),
  data: z.optional(ZDeviceTypeData),
  error: z.boolean(),
  error_message: z.optional(z.string())
})

export type DeviceType = z.infer<typeof ZDeviceType>

export function deviceTypeService (
  categoryTypeId: string,
  onSuccess: (assetCategories: DeviceType[], httpStatus: number) => void,
  onFailure: (errorMessage: any, httpStatus: number) => void,
  communicationProtocol?: string
): void {
  let url = `/assetrest/api/v2/udp/tiq/assets/devicetypes?categoryTypeId=${categoryTypeId}&assetGroup=device`
  if (communicationProtocol !== null && communicationProtocol !== undefined && communicationProtocol !== '') {
    url += `&communicationProtocol=${communicationProtocol}`
  }

  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response) => {
      const responseData = response.data

      if (responseData.error === false) {
        if (responseData.data !== null && responseData.data !== undefined) {
          onSuccess(responseData.data, responseData.http_status)
        } else {
          onFailure(responseData.error, responseData.http_status)
        }
      } else {
        onFailure(responseData.error_message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(
          error.response.data !== undefined || error.response.data !== null
            ? error.response.data.error_message
            : 'Network Error',
          error.response.status
        )
      } else {
        onFailure('Network Error', 404)
      }
    })
}
